<div class="genie-page">

  <!-- Page Header -->
  <div class="genie-page-header">
    <div class="header-left">
      <div class="backButton" [routerLink]="['/users']">
        <img src="/assets/icons/arrow-left.svg" alt="Go back" />
      </div>
      <div class="header-title-group">
        <p class="genie-page-title">{{ 'User Details' | translate }}</p>
        <p class="genie-page-subtitle">{{ 'View and manage user information, roles, and contact details.' | translate }}</p>
      </div>
    </div>
    <div class="header-right">
      <button class="genie-btn approve-btn" (click)="approveUser()" *ngIf="userData && !adminUser && userData.status === 'pending'">
        {{ 'Approve User' | translate }}
      </button>
      <button class="genie-btn primary" (click)="adminUser ? updateNewRole() : saveUser()" *ngIf="userData">
        {{ 'Save Edits' | translate }}
      </button>
    </div>
  </div>

  <!-- User Info Card -->
  <div class="section-card" *ngIf="userData">
    <div class="card-header">
      <h3>{{ 'User Info' | translate }}</h3>
      <span *ngIf="userData.status === 'pending'" class="genie-badge warning">{{ 'Pending Approval' | translate }}</span>
      <span *ngIf="userData.status === 'approved'" class="genie-badge success">{{ 'Approved' | translate }}</span>
    </div>
    <div class="card-body">

      <!-- Row 1: First Name + Last Name -->
      <div class="fields-grid-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'First Name' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="userData.given_name || userData.first_name || ''" placeholder="{{ 'First Name' | translate }}" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Last Name' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="userData.family_name || userData.last_name || ''" placeholder="{{ 'Last Name' | translate }}" />
          </div>
        </div>
      </div>

      <!-- Row 2: Email Address + Phone Number -->
      <div class="fields-grid-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Email Address' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="userData.email || ''" [placeholder]="'example@gmail.com' | translate" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Phone Number' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="userData.phoneNumber || userData.phone_number || ''" placeholder="{{ 'Phone Number' | translate }}" />
          </div>
        </div>
      </div>

      <!-- Non-admin specific fields -->
      <ng-container *ngIf="!adminUser">

        <!-- Row 3: Points + Join Date -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Points' | translate }}</label>
            </div>
            <div class="genie-input">
              <input readonly [value]="userData.totalPoints || '-'" placeholder="-" />
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Join Date' | translate }}</label>
            </div>
            <div class="genie-input">
              <input readonly [value]="userData.updated_at || userData.registration_date || ''" placeholder="{{ 'Join Date' | translate }}" />
            </div>
          </div>
        </div>

        <!-- Row 4: Email Verification + User Role -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Email Verification' | translate }}</label>
            </div>
            <div class="genie-input">
              <input readonly [value]="userData.email_verified" placeholder="false" />
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'User Role' | translate }}</label>
            </div>
            <div class="genie-input">
              <select [(ngModel)]="typeValue" name="userRole">
                <option value="customer">{{ 'Customer' | translate }}</option>
                <option value="merchant">{{ 'Merchant' | translate }}</option>
                <option value="admin">{{ 'Admin' | translate }}</option>
                <option value="vendor">{{ 'Vendor' | translate }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Row 5: Location + Type (editable) -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Location' | translate }}</label>
            </div>
            <div class="genie-input">
              <input [(ngModel)]="location" placeholder="{{ 'Enter Location' | translate }}" />
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Type' | translate }}</label>
            </div>
            <div class="genie-input">
              <input [(ngModel)]="typeValue" placeholder="{{ 'Enter Type' | translate }}" />
            </div>
          </div>
        </div>

      </ng-container>

      <!-- Admin-specific: editable User Role -->
      <div class="fields-grid-row" *ngIf="adminUser">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'User Role' | translate }}</label>
          </div>
          <!-- Hidden select keeps ngModel validation intact -->
          <select required [(ngModel)]="newRole" name="newRole" style="display:none"></select>
          <div #roleTrigger class="genie-input custom-role-select" (click)="toggleRoleDropdown($event)">
            <span [class.select-placeholder]="!newRole">
              {{ newRole ? (getRoleOptionLabel(newRole) | translate) : ('Select User Role' | translate) }}
            </span>
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" class="select-arrow" [class.open]="roleDropdownOpen">
              <path d="M0 0l5 6 5-6z" fill="#ADADAD"/>
            </svg>
          </div>
          <div class="role-dropdown-panel" *ngIf="roleDropdownOpen"
            [style.top.px]="dropdownTop" [style.left.px]="dropdownLeft" [style.width.px]="dropdownWidth"
            (click)="$event.stopPropagation()">
            <div class="role-option" *ngFor="let opt of roleOptions" (click)="selectRole(opt.value, $event)">
              {{ opt.label | translate  }}
            </div>
          </div>
        </div>
        <div class="field-wrapper"></div>
      </div>

    </div>
  </div>

  <!-- Last Order Details Card -->
  <div class="section-card" *ngIf="ELEMENT_DATA.length">
    <div class="card-header">
      <h3>{{ 'Last Order Details' | translate }}</h3>
    </div>
    <div class="card-body">
      <div class="fields-grid-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Order ID' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="'#' + ELEMENT_DATA[ELEMENT_DATA.length - 1].humId" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Total Order' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="ELEMENT_DATA[ELEMENT_DATA.length - 1].total" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Payment Method' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="ELEMENT_DATA[ELEMENT_DATA.length - 1].payment_method" />
          </div>
        </div>
      </div>
      <div class="fields-grid-row">
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Order Status' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="ELEMENT_DATA[ELEMENT_DATA.length - 1].status" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Order Date' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="ELEMENT_DATA[ELEMENT_DATA.length - 1].date" />
          </div>
        </div>
        <div class="field-wrapper">
          <div class="field-label-row">
            <label>{{ 'Total Orders Value' | translate }}</label>
          </div>
          <div class="genie-input">
            <input readonly [value]="totalOrdersPrice" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Orders List Table -->
  <div class="section-card orders-card" *ngIf="orders && !adminUser">
    <!-- Toolbar -->
    <div class="genie-toolbar">
      <div class="toolbar-left">
        <h3>{{ 'Orders List' | translate }}</h3>
      </div>
      <div class="toolbar-right">
        <div class="search-input-wrapper">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.75 10.5C8.37335 10.5 10.5 8.37335 10.5 5.75C10.5 3.12665 8.37335 1 5.75 1C3.12665 1 1 3.12665 1 5.75C1 8.37335 3.12665 10.5 5.75 10.5Z" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M11 11L10 10" stroke="#ADADAD" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <input (input)="applyFilter()" [(ngModel)]="searchText" name="searchText" placeholder="{{ 'Search' | translate }}" type="text" />
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <div class="genie-table-wrapper">
      <table class="genie-table">
        <thead>
          <tr>
            <th class="col-center">{{ 'Order ID' | translate }}</th>
            <th class="col-center">{{ 'Order Date' | translate }}</th>
            <th>{{ 'Payment Method' | translate }}</th>
            <th class="col-center">{{ 'Status' | translate }}</th>
            <th class="col-center">{{ 'Total' | translate }}</th>
            <th class="col-actions"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of displayedOrders">
            <td class="col-center">{{ order.humId || '-' }}</td>
            <td class="col-center">{{ order.date | date:'yyyy/MM/dd HH:mm:ss' }}</td>
            <td>{{ order.payment_method | translate }}</td>
            <td class="col-center">
              <span class="genie-badge" [ngClass]="{
                'success': order.status.toLowerCase() === 'completed' || order.status.toLowerCase() === 'complete' || order.status.toLowerCase() === 'processing',
                'warning': order.status.toLowerCase() === 'pending' || order.status.toLowerCase() === 'on-hold',
                'danger': order.status.toLowerCase() === 'cancelled' || order.status.toLowerCase() === 'failed' || order.status.toLowerCase() === 'refunded'
              }">{{ order.status | translate }}</span>
            </td>
            <td class="col-center">{{ order.total | translate }}</td>
            <td class="col-actions">
              <div class="genie-action-buttons">
                <button class="genie-icon-btn view" (click)="editOrder(order.id)">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.5 2.8125C4.375 2.8125 1.75625 4.80625 0.625 7.5C1.75625 10.1937 4.375 12.1875 7.5 12.1875C10.625 12.1875 13.2437 10.1937 14.375 7.5C13.2437 4.80625 10.625 2.8125 7.5 2.8125Z" stroke="#ADADAD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7.5 9.6875C8.70812 9.6875 9.6875 8.70812 9.6875 7.5C9.6875 6.29188 8.70812 5.3125 7.5 5.3125C6.29188 5.3125 5.3125 6.29188 5.3125 7.5C5.3125 8.70812 6.29188 9.6875 7.5 9.6875Z" stroke="#ADADAD" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="displayedOrders.length === 0">
            <td colspan="6" class="empty-row">{{ 'No Orders Yet' | translate }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Custom Pagination -->
    <div class="genie-pagination">
      <div class="pagination-info">
        <span class="current-page">{{ pageIndex + 1 }}</span>
        <span class="page-separator">{{ 'of' | translate }}</span>
        <span class="total-pages">{{ getTotalPages() }}</span>
      </div>
      <div class="pagination-controls">
        <button class="page-btn prev" [disabled]="pageIndex === 0" (click)="previousPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 7.5L3.75 5L6.25 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="page-btn next" [disabled]="pageIndex >= getTotalPages() - 1" (click)="nextPage()">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 7.5L6.25 5L3.75 2.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!orders" class="genie-empty-state">
    <p>{{ 'No Orders Yet' | translate }}</p>
  </div>

</div>
